import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/glossary/layout.tsx")